import React from "react";

const GraphSection = () => {
  return (
    <div className="">
      <div className="h-full w-full  md:hidden">
        <img
          src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%208346.png?updatedAt=1695900170324"
          width={300}
          height={365}
          alt="graph"
          className="h-auto w-full"
        />
      </div>
      <div className="hidden h-full w-full md:block">
        <img
          alt="a line graph showing the growth of a cell phone"
          src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%209125.png?updatedAt=1694700393696"
          width={300}
          height={365}
          className="h-auto w-full"
        />
      </div>
    </div>
  );
};

export default GraphSection;
